<template>
  <div class="home-project">
    <a v-if="ad.imageUrl" :href="ad.turnUrl || 'javascript:void(0)'" :target="ad.turnUrl ? '_blank' : '_self'">
      <img :src="ad.imageUrl" />
    </a>
  </div>
</template>

<script>
import { fetchAdDetails, resolveAdImage } from '../../../api'

export default {
  name: 'HomeProject',
  data() {
    return {
      ad: {}
    }
  },
  created() {
    this.loadAd()
  },
  methods: {
    async loadAd() {
      const list = await fetchAdDetails('index_content_btm_banner')
      this.ad = list[0] || {}
      this.ad.imageUrl = resolveAdImage(this.ad.imageUrl)
    }
  }
}
</script>

<style scoped>
.home-project {
  width: 1400px;
  margin: 0 auto;
  padding-top: 30px;
  margin-bottom: 30px;
}
.home-project a {
  display: block;
  text-decoration: none;
}
.home-project img {
  display: block;
  width: 1400px;
  height: 240px;
  object-fit: cover;
  border-radius: 4px;
}
</style>
